import { useState } from 'react'
const doHours = (time) => {
  return time.hour < 11 ? { ...time, hour: time.hour + 1 } : 0
}
const doMinutes = (time) => {
  return time.minute < 60
    ? { ...time, minute: time.minute + 1 }
    : doHours({ ...time, minute: 0 })
}

const doSeconds = (time) => {
  return time.second < 60
    ? { ...time, second: time.second + 1 }
    : doMinutes({ ...time, second: 0 })
}

const doTime = (time) => doSeconds(time)

export const useTime = (
  { hour, minute, day, second } = { hour: 0, minute: 0, second: 0, day: 0 }
) => {
  const [time, update] = useState({ hour, minute, second, day })

  const setTime = () => {
    update((time) => doTime(time))
  }

  return [time, setTime]
}
